module.exports = __webpack_public_path__ + "static/media/galt-home-logo.163187fa.png";